
import React from 'react'
import { mdx } from '@mdx-js/react'

/* @jsxRuntime classic */
/* @jsx mdx */



const layoutProps = {
  
};
const MDXLayout = "wrapper"
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <p><em parentName="p">{`Qui le fabrique?`}</em></p>
    <p>{`L’ARNm-1273 ou Spikevax est développé par la firme américaine Moderna. La
production européenne du principe actif se fait dans
`}<a parentName="p" {...{
        "href": "181169450769"
      }}>{`les usines Lonza`}</a>{`, à Viège. Le 15 mars 2021, Swissmedic a annoncé
avoir délivré à cette société une autorisation d'exploitation pour un
`}<a parentName="p" {...{
        "href": "https://www.swissmedic.ch/swissmedic/fr/home/news/coronavirus-covid-19/lonza-weitere-betriebsbewilligung-produktion-covid-19-ws.html"
      }}>{`nouveau site de production`}</a>{`.`}</p>
    </MDXLayout>;
}

;
MDXContent.isMDXComponent = true;